// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3zKib","detailsBorder":"styles_detailsBorder__ZbYeP"};